import { useState } from "react"
import styled from "styled-components"

//Styled Components
const Container=styled.div`
// background-color: orange;
color:#182C47;
display: flex;
align-items:center;
justify-content:center;
flex-direction: column;
gap: 20px;
height: 80vh;
margin: 20px auto;
width: 90vw;
`
const Title=styled.h1`
font-weight:400;
`
const FormConatiner=styled.div`
// background-color: yellow;
display:flex;
justify-content:Center;
min-height:50%;
width: 40%;
`
const Form=styled.div`
display: flex;
// align-items:Center;
padding: 20px;
gap: 15px;
justify-content:center;
flex-direction:column;
position:relative;
top: 2rem;
`
 const Label=styled.label`
 margin-top:10px;
 `
const Input=styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 0.5px solid gray;
  font-size: 17px;
  width: 300px;
  &:hover{
    outline:none;
  };
  &:focus{
    outline: none;
  }
`
const Button=styled.button`
 border: none;
 border-radius: 26px;
 background-color:#182C47;
 color:#fff;
 cursor: pointer;
 height: 34px;
 position: relative;
 top: 2.5rem;
 left: 40%;
 width: 80px;
`
const Anchor=styled.a`
color:white;
`
const Contact=()=>{

  const [senderName,setSenderName] = useState('');
  const [senderMail,setSenderMail] = useState('');
  const [senderMessage,setSenderMessage] = useState('');
  const emailAddress="mr.kamalchakma@gmail.com"
  const subject="Message from DMWS"
  const body = `Name : ${senderName}, Email : ${senderMail}, Message : ${senderMessage}`;
  const mailTo=`mailto:${emailAddress}?subject=${subject}&body=${encodeURIComponent(body)}`

    return(
           <Container> 
             <Title>Contact Us</Title>
             <FormConatiner>
               <Form>
                <Label>Name</Label>
                 <Input type="text" onChange={(e)=>{setSenderName(e.target.value)}}/>
                 <Label>Email</Label>
                 <Input type="email" onChange={(e)=>{setSenderMail(e.target.value)}}/>
                 <Label>Message</Label>
                 <Input type="text" onChange={(e)=>{setSenderMessage(e.target.value)}}></Input>
                 <Button><Anchor href={mailTo}>Submit</Anchor></Button>
               </Form>
             </FormConatiner>
           </Container>
    )
}
export default Contact